export const CUSTOM_PAGES_API_PATH = "custom-pages"

export const CUSTOM_PAGES_PATHS = {
	GET_CUSTOM_PAGES: "/list?campaignId={campaignId}",
	CREATE_CUSTOM_PAGE: "",
	UPDATE_CUSTOM_PAGE: "",
	UPDATE_MULTIPLE_CUSTOM_PAGES: "/multiple",
	DELETE_CUSTOM_PAGE: "/?customPageId={customPageId}",
	UNSET_ALL_CTAS: "/unset-all-ctas?campaignId={campaignId}",
};